<template>
    <div class="__action-part-mailchimp">
        <div class="layout-row flex flex-center gap-40 margin-b-30">
            <select-field
		            class="flex"
		            placeholder="Select an action to trigger"
                caption="Action"
                :loading="spin"
                @input="actionChanged($event)"
                :options="actions"
                label="caption"
                v-model="automation.type_id"/>

            <div class="form_group">
              <v-switch label="Use the customer optin email?" :value="automation.send_to_optin_email"
                        v-model="automation.send_to_optin_email"  @change="updated()"
                        info="When checked (default), the customer's optin email will be used when the automation is triggered instead of their payer email in case they're different.">
              </v-switch>
            </div>
        </div>

        <select-field v-if="automation.type_id && acLists.length" class="margin-b-30"
            caption="List"
            label="caption"
            @input="updated"
	          :loading="spin"
            :options="acLists"
            v-model="automation.list"
            searchable clearable/>

	    <select-field v-if="automation.type_id && acLists.length"
	                  placeholder="Type a tag to add"
	                  caption="Type and hit Enter to insert a new tag"
	                  @input="updated"
	                  :loading="spin"
	                  readonly="false"
	                  :options="automation.tags||[]"
	                  v-model="automation.tags"
	                  searchable
	                  multiple
	                  taggable />
    </div>
</template>

<script>
import API from "@/api"
import VSwitch from "@/components/base/v-switch";
import SelectField from "@/components/base/select-field";

export default {
    name: 'Mailchimp',
    components: {
	    SelectField,
        VSwitch,
    },
  mixins: [API],
	props:{
		automation:{
			type:Object,
			// default:()=> {}
		},
		product:{
			type:Object,
		},
		actions:{
			type:Array,
		},
		integration:{
			type:Object,
		},
	},
    data() {
      return {
        spin: false,
	      acLists: [],
      }
    },
    computed: {
			isValid(){
				return (!!this.automation.type_id) && (this.automation.list || (this.automation.tags && this.automation.tags.length))
			}
    },
    methods: {
      async actionChanged(val) {
				this.$nextTick(()=>{
					this.updated();
				})
      },
	    updated() {
        let caption = "";

        if (this.automation.list) {
          let list = this.acLists.find(item => item.id === this.automation.list);
          if (list && list.caption) {
            caption = list.caption;
          }
        }

        this.automation.action_caption = caption;
		    this.$emit('valid', this.isValid)
	    },
	    async loadLists() {
		    try {
			    this.spin = true
			    let acRes = await this.api.integrations.method(this.integration.name, 'get-lists',
					    {"id":0,"arg1":"","arg2":""});
			    this.acLists = [];

			    if (!acRes || acRes.error)
				    this.$error(acRes, "Integration error! Check your integration credentials and try again.");
			    else
				    this.acLists = acRes;
		    } catch (e) {
			    this.$error(e)
		    } finally {
			    this.spin = false;
			    this.updated()
		    }
	    }
    },
    async created() {
	    if (this.automation) {
		    if (!this.automation.content)
			    this.$set(this.automation, 'content', {})
	    }
			await this.loadLists()
    },
}
</script>
<style lang="scss" scoped>
.__action-part-mailchimp {

}
</style>
